import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

/**
 * Home page component
 * Simplified landing page for the مجالسنا system with just two main buttons
 */
const Home = () => {
  return (
    <Box>
      {/* Hero Section with Two Main Buttons */}
      <Box
        bg={useColorModeValue('transparent', 'gray.900')}
        minH="calc(100vh - 140px)" // Adjust for header and footer
        display="flex"
        alignItems="center"
        py={10}
      >
        <Container maxW="container.xl">
          <Stack spacing={10} align="center" textAlign="center">
            <Image
              src="/images/logo.png"
              alt="مجالسنا"
              maxW={{ base: "200px", md: "300px" }}
              mb={4}
            />
            
            <Heading
              as="h1"
              fontSize={{ base: '3xl', md: '5xl' }}
              fontWeight="bold"
              color="brown.600"
            >
              نظام مجالسنا
              <Text as="span" display="block" fontSize={{ base: '2xl', md: '3xl' }} mt={2} color="teal.600">
                لإدارة ترشيحات المرشحين
              </Text>
            </Heading>
            
            <Text 
              fontSize={{ base: "lg", md: "xl" }} 
              color="gray.600"
              maxW="2xl"
              mb={6}
            >
              منصة متكاملة لإدارة عملية ترشيح المرشحين عبر الإدارة الرئيسية والفروع والمراكز
            </Text>
            
            <Flex 
              direction={{ base: "column", md: "row" }}
              gap={{ base: 4, md: 8 }}
              w={{ base: "100%", md: "auto" }}
              justify="center"
              mt={6}
            >
              <Button
                as={RouterLink}
                to="/apply"
                size="lg"
                height="70px"
                width={{ base: "100%", md: "240px" }}
                fontSize="xl"
                colorScheme="brown"
                borderRadius="md"
                boxShadow="lg"
              >
                قدم طلب ترشيح
              </Button>
              
              <Button
                as={RouterLink}
                to="/login"
                size="lg"
                height="70px"
                width={{ base: "100%", md: "240px" }}
                fontSize="xl"
                colorScheme="teal"
                borderRadius="md"
                boxShadow="lg"
              >
                تسجيل الدخول
              </Button>
            </Flex>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
